<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      :class="hideButtons ? 'sm6' : 'sm4'"
      xs12
    >
      <v-text-field
        v-model="name"
        :disabled="disableField()"
        :label="$t('Name')"
        outline
        class="mx-1"
      />
    </v-flex>
    <v-flex
      xs12
      sm6
    >
      <v-text-field
        v-model="val"
        :disabled="disableField()"
        :label="$t('Value')"
        outline
        class="mx-1"
      />
    </v-flex>
    <v-flex
      v-if="!hideButtons"
      xs12
      sm2
    >
      <v-btn
        :disabled="disableCreation()"
        icon
        color="success"
        @click="create"
      >
        <v-icon>check</v-icon>
      </v-btn>
      <v-btn
        :disabled="isChildVariation()"
        icon
        color="error"
        @click="$emit('removed', property.key)"
      >
        <v-icon v-if="!isNew">delete</v-icon>
        <v-icon v-else>close</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import randomstr from 'randomstring'

export default {
  name: 'ProductProperty',

  props: {
    value: {
      required: false,
      type: Object,
      default: () => {
        return {
          key: null,
          name: '',
          value: null
        }
      }
    },
    hideButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    isNew: {
      required: false,
      type: Boolean,
      default: false
    },
    model: {
      required: false,
      type: Object,
      default: null
    }
  },

  data () {
    return {
      property: {
        key: '',
        name: '',
        value: null
      },
      isCreated: false
    }
  },

  computed: {
    name: {
      get () {
        return this.property.name
      },
      set (value) {
        this.property.name = value
        this.$emit('change', this.property)
      }
    },
    val: {
      get () {
        return this.property.value
      },
      set (value) {
        this.property.value = value
        this.$emit('change', this.property)
      }
    }
  },

  created () {
    this.property.key = this.value.key || randomstr.generate(16)
    this.property.name = this.value.name
    this.property.value = this.value.value
  },

  methods: {
    disableField () {
      if (this.isChildVariation()) {
        return true
      }

      return this.value.key === null && !this.isNew
    },

    disableCreation () {
      if (!this.isNew) {
        return this.isCreated || this.value.key !== null
      }

      return !(!!this.name && !!this.val)
    },

    isChildVariation () {
      if (this.isNew || !this.model || !this.model.parent) {
        return false
      }

      const variants = this.model.parent.variants || []
      const properties = this.model.properties || []
      if (!variants.length) {
        return false
      }

      const variations = properties
        .filter(p => variants.some(v => p.name === v.name && v.options.includes(p.value)))
        .map(p => p.key)

      return variations.includes(this.value.key)
    },

    create () {
      this.$emit('created', this.property)
      this.isCreated = true
    }
  }
}
</script>
